// Action creators

// fetch data from an API
// fetch call gets returned from an outer function & outer function has dispatch as a param
// if want to access the state inside the action creator, can add getState in the param's list
var fetchMembers = () => {
  return function (dispatch) {
    return fetch('api/user/list')
      .then(results => {
        return results.json();
        }).then(json => {
            json.sort(function (a, b) {
                var nameA = a.firstName.toLowerCase(), nameB = b.firstName.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0;
            });
            dispatch({ type: "DATA_LOADED", payload: json }); //need to call dispatch inside the async function for dispatching the action
        // dispatch({ type: "DATA_LOADED", payload: json })
      });
    // add error handler
  };
}

export default { 'FETCH_MEMBERS': fetchMembers };


// WEBPACK FOOTER //
// ./src/actions/member_actions.js